module.exports = __webpack_public_path__ + "static/img/group@2x.033897e2.png";